// 사용자의 Role 변경
export const UPDATE_ROLE= "UPDATE_ROLE";
